import { render } from "./DeleteAccountModal.vue?vue&type=template&id=fdfb2eae&scoped=true"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js"

import "./DeleteAccountModal.vue?vue&type=style&index=0&id=fdfb2eae&lang=scss&scoped=true"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfb2eae"]])

export default __exports__